export const ProdLocations = [
  { value: "all_location", label: "All Locations" },
  { value: "Elk Grove", label: "Elk Grove" },
  { value: "Sacramento", label: "Sacramento" },
  { value: "Stockton", label: "Stockton" },
  { value: "Turlock", label: "Turlock" },
  { value: "Modesto", label: "Modesto" },
  { value: "Los Banos", label: "Los Banos" },
  { value: "Merced", label: "Merced" },
  { value: "Salida", label: "Salida" },
  { value: "Fresno", label: "Fresno" },
  { value: "Ripon", label: "Ripon" },
  { value: "Patterson", label: "Patterson" },
  { value: " Softobiz Test", label: " Softobiz Test" }, // Note the leading space is preserved
  { value: "Test & Practice ", label: "Test & Practice " }, // Note the trailing space is preserved
];

export const ProdFranchiseLocations = [
  { value: "all_location", label: "All Locations" },
  {
    value: "Genesis Behavior Center Las Vegas",
    label: "Genesis Behavior Center Las Vegas",
  },
  {
    value: "Genesis Behavior Center Glendale",
    label: "Genesis Behavior Center Glendale",
  },
  { value: "Mental Health Life, LLC ", label: "Mental Health Life, LLC " }, // Note the trailing space is preserved
];

export const DevLocations = [
  { value: "all_location", label: "All Locations" },
  { value: "Elk Grove", label: "Elk Grove" },
  { value: "Stockton", label: "Stockton" },
  { value: "Turlock", label: "Turlock" },
  { value: "Fresno", label: "Fresno" },
  { value: "Sacramento", label: "Sacramento" },
  { value: "Merced", label: "Merced" },
];

export const learnerOptions = [
  { label: "All", value: "learnerall" },
  { label: "Learner 1", value: "learner0" },
  { label: "Learner 2", value: "learner1" },
];

export const programOptions = [
    { label: "All", value: "All" },
    { label: "Behavior", value: "Behavior" },
    { label: "Skill", value: "Skill" },
];

export const programOptions2 = [
    { label: "All", value: "All" },
    { label: "Behavior", value: "Behavior" },
    { label: "Skill", value: "Skill" },
    { label: "Caregiver Training", value: "Parental_Training" },
];